export default function CopyGamePage() {
    return null
}